type Totals = {
    totalAmount: string
    baseCurrencyTotalAmount: string
    baseCurrencyBalance: string
    baseCurrencyTotalValueAmount: string
}

export type SearchTotalsDtoAttributes = {
    totals: Totals,
    totalItemsCount: number
}

export type SearchTotalsDto = {
    id: string
    type: string
    attributes: SearchTotalsDtoAttributes
}

export default class SearchTotals {
    private dto: SearchTotalsDto

    constructor(dto: SearchTotalsDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "items-totals"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): SearchTotalsDtoAttributes {
        return this.dto.attributes
    }

    getTotals() {
        return this.dto.attributes.totals

    }

    getTotalAmount = () => {
        return this.getTotals().totalAmount ?? "0"
    }

    getTotalItemsCount(): number {
        return this.dto.attributes.totalItemsCount
    }

}


// WEBPACK FOOTER //
// ./src/state/search/SearchTotals.ts